import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import('./Header'),
  LoadingComponent: () => <div className="header-placeholder" />
});



// WEBPACK FOOTER //
// ./src/universal/components/Header/AsyncHeader.js